export default "__VITE_ASSET__10acea1a__"